/* Sectors Page Effects */

textArray = [];

function createFields(thisList) {

    textArray = [];

    $(thisList).find(".skill").map(function(){
       textArray.push($(this).text());
    });

    var numberOfPoints = textArray.length;

    $('.field').remove();
    var container = $('#modal-container');
    for(var i = 0; i < + numberOfPoints; i++) {
        $('<li/>', {
            'class': 'field',
            'text': textArray[i]
        }).appendTo(container);
    }
}

$( ".sector" ).click(function() {
    createFields(this);
});


$(document).on('open.zf.reveal', function()
{
    var ST = new SplitText('.field', {type:"words"}), chars=ST.words , l=ST.words.length;
    //TweenMax.set(chars, {opacity:0, scale:2, y:"-50"});
    TweenMax.set(".modal-container", {opacity:0});

    setTimeout(function(){
        TweenMax.staggerFrom(chars, 1.5, {color:"#ff5d56", opacity:0, scale:3, rotationX:180, cycle:{delay:function(i){return Math.abs(Math.floor(l/2)-i)*0.02}},ease:Back.easeIn}, 0.04, highlight);
    }, 100);

    function highlight() {
        console.log('run');
        TweenMax.staggerTo(chars, 2, {color:"#dddddd", repeat:-1, yoyo:true, cycle:{delay:function(i){return Math.abs(Math.floor(l/2)-i)*0.06}},ease:Back.easeIn}, 0.06);
    }
    function getRandomInt(max) {
        return Math.floor(Math.random() * Math.floor(max));
    }

});